import { createContext, useContext } from 'react'
import { useApolloClient } from '@apollo/client'

// 'all' (default) refetches every query in the cache, including skipped ones
// (which fire with stale/empty variables). 'active' refetches only queries
// with mounted subscribers — necessary when an app uses Apollo BatchHttpLink,
// because a single bad op in a batch fails the entire batch.
//
// Apps using BatchHttpLink should wrap their tree with:
//   <RefetchIncludeCtx.Provider value="active">
export const RefetchIncludeCtx = createContext(/** @type {'all' | 'active'} */('all'))

export const useRefetchAll = () => {
  const apolloClient = useApolloClient()
  const include = useContext(RefetchIncludeCtx)
  const refetchAll = async () => {
    try {
      await apolloClient.refetchQueries({include})
    } catch {
      // some api calls fail when logged out, don't surface errors
    }
  }
  return {refetchAll}
}
